define('modules/page_generator/views/variant_list',['require','exports','module','base/collectionview','./variant_item','ldsh!../templates/variant_list'],function(require, exports, module){
  "use strict";
  var CollectionView = require("base/collectionview"),
      VariantItem = require("./variant_item");

  module.exports = CollectionView.extend({
    template: require("ldsh!../templates/variant_list"),
    className: "ed-dropdown",
    itemContainer: "ul",
    itemView: VariantItem,
    initialize: function(options){
      this.pageId = options.pageId;
      this.viewState = options.viewState;
      this._addChildHandlers();
      this._addStateHandlers();
    },

    _addChildHandlers: function(){
      this.listenTo(this.childVent, "variant:select", function(itemView){
        this.viewState.set("currentVariant", itemView.model);
      });
    },

    _addStateHandlers: function(){
      this.listenTo(this.viewState, "change:currentVariant", function(model, variant) {
        var variantName = variant.get("name"),
            variantId = variant.id,
            platform = variant.get("platform");
        //set variant name on list
        this.$(".js-current-variant").text(variantName);
        //disable currently selected
        _.each(this._childViews, function(itemView) {
          itemView.$("a").attr("disabled", (itemView.model.id === variantId));
        });
      });
    }
  });
});

